import { comparison } from '@/content/site';
import { ScrollReveal } from '@/components/ScrollReveal';
import { Section } from '@/components/Section';
import './ComparisonTable.css';

export function ComparisonTable() {
  return (
    <Section id="comparacion" title={comparison.title} lead={comparison.lead} className="comparison-section">
      <ScrollReveal>
        <div className="comparison-table-wrap">
          <table className="comparison-table">
            <thead>
              <tr>
                {comparison.columns.map((col) => (
                  <th key={col} scope="col">
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {comparison.rows.map((row) => (
                <tr key={row.feature}>
                  <th scope="row">{row.feature}</th>
                  <td>{row.others}</td>
                  <td className="comparison-table__ours">{row.ours}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </ScrollReveal>
    </Section>
  );
}
